module.exports = __webpack_public_path__ + "img/ellipse.84d39794.png";